import { Component } from '@angular/core';

import { BusinessType } from '@camelot/services';
import { BusinessTypeComponent } from '@camelot/ui';

import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'grid-business-type-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [BusinessTypeComponent],
  template: `
    @if (this.value) {
      <div class="flex-start align-center" style="height: 100%">
        <cam-business-type class="d-flex" [businessType]="this.value"></cam-business-type>
      </div>
    }
  `,
})
export class GridBusinessTypeCellComponent extends AbstractCellComponent<any, BusinessType> {}
